import {
  registerDecorator,
  ValidationArguments,
  ValidationOptions,
} from "class-validator"
import dayjs from "dayjs"

export function IsBeforeRelatedDate(
  constraints: string,
  validationOptions?: ValidationOptions,
) {
  return function (object: Object, propertyName: string) {
    registerDecorator({
      name: "isBeforeRelatedDate",
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      constraints: [constraints],
      validator: {
        validate(value: any, args: ValidationArguments) {
          const [relatedPropertyName] = args.constraints
          const relatedValue = (args.object as any)[relatedPropertyName]

          // Validation passes if the related date is after the current date
          if (!value || !relatedValue) {
            return true // Skip validation if either date is not provided
          }

          const currentDate = dayjs(value).endOf("day")
          const relatedDate = dayjs(relatedValue).endOf("day")

          return currentDate.isSameOrBefore(relatedDate)
        },
        defaultMessage(args: ValidationArguments) {
          const [relatedPropertyName] = args.constraints
          return `${args.property} is not before or equal to ${relatedPropertyName}`
        },
      },
    })
  }
}
